const siteKey = "6LddLVIqAAAAAFfN-16lkaPbdp980kGxMjVjzqjP";
const secretKey = "6LddLVIqAAAAABHJl83DQAY7hplaDaCl3x8jcXkv";

const phoneNumber = "+2348023187712";

const dark = "../../images/svg/dark.svg";
const light = "../../images/svg/light.svg";

const isTabWidth = "(max-width:900px)";

const whiteLogo = "../../images/logos/6334_white.png";

const menuItems = [
  { path: "/", label: "Home" },
  { path: "/about", label: "About Us" },
  { path: "/services", label: "Services" },
  { path: "/team", label: "Team" },
  { path: "/contact", label: "Contact Us" },
  // { path: "/downloads", label: "Downloads" },
];

const buildings = [
  "../../images/buildings/burj.png",
  "../../images/buildings/malaytwin.png",
  "../../images/buildings/shard.png",
  "../../images/buildings/empire.png",
  "../../images/buildings/taipei.png",
  "../../images/buildings/eiffel.png",
  "../../images/buildings/needle.png",
  "../../images/buildings/chrysler.png",
];

const designBarButtons = [
  { label: "Schedule a Consultation", path: "/contact#consult" },
];

const endButtons = [
  { label: "Schedule a Consultation", path: "/contact#consult" },
];

const teamButtons = [{ label: "Meet our Team", path: "/team" }];

const servicesButtons = [{ label: "Explore our Solutions", path: "/services" }];

const contactButtons = [{ label: "Contact Us", path: "/contact" }];

const contactHeaderButtons = [
  { label: "Make an Inquiry", path: "/contact#inquiry" },
  { label: "Book a Meeting", path: "/contact#consult" },
];

const servicesHeaderButtons = [
  { label: "Schedule a Consultation", path: "/contact#consult" },
];

const teamHeaderButtons = [
  { label: "Schedule a Consultation", path: "/contact#consult" },
];

const sentences = [
  "Welcome, how may we be of service?", // English
  "Bienvenido, ¿en qué podemos servirle?", // Spanish
  "Bienvenue, comment pouvons-nous vous aider ?", // French
  "Willkommen, wie können wir Ihnen behilflich sein?", // German
  "Benvenuto, come possiamo esserti utili?", // Italian
  "ようこそ、どのようにお手伝いできますか？", // Japanese
  "환영합니다, 어떻게 도와드릴까요?", // Korean
  "欢迎，我们能为您提供什么帮助？", // Chinese
];

const competences = [
  {
    background:
      "linear-gradient(to bottom, rgba(255, 255, 255, 0), rgba(0, 0, 0, 1)), url(../../images/homeslider/capacity.png)",
    tagline: "Human Resources Consultancy & Capacity Development",
    description: `We assist in developing a customized human resources strategy, including creating a clear organizational structure with detailed organograms and well-defined job descriptions. Additionally, we provide targeted training programs to enhance employee skills and ensure your team is aligned with your business objectives.`,
  },
  {
    background:
      "linear-gradient(to bottom, rgba(255, 255, 255, 0), rgba(0, 0, 0, 1)), url(../../images/homeslider/framework.png)",
    tagline: "Framework Design & Execution",
    description:
      "We utilize innovative frameworks such as Access to Finance and Financial Inclusion Schemes to enhance opportunities for growth. These approaches help ensure broader access to financial resources, empowering businesses and individuals to achieve sustainable success.",
  },
  {
    background:
      "linear-gradient(to bottom, rgba(255, 255, 255, 0), rgba(0, 0, 0, 1)), url(../../images/homeslider/project.png)",
    tagline: "Project Management",
    description:
      "We manage projects by conducting thorough research and developing tailored Monitoring and Evaluation (M&E) templates for effective design and deployment. This ensures that each project is systematically tracked, measured, and optimized for success.",
  },
  {
    background:
      "linear-gradient(to bottom, rgba(255, 255, 255, 0), rgba(0, 0, 0, 1)), url(../../images/homeslider/org.png)",
    tagline: "Organizational Design",
    description: `We specialize in developing process mapping, policy design, and Standard Operating Procedures (SOPs) to streamline operations. These tools ensure clarity, consistency, and efficiency across all organizational functions.`,
  },
  {
    background:
      "linear-gradient(to bottom, rgba(255, 255, 255, 0), rgba(0, 0, 0, 1)), url(../../images/homeslider/monitor.png)",
    tagline: "Monitoring & Evaluation",
    description: `We ensure that projects are delivered on time and within budget by implementing rigorous Monitoring and Evaluation (M&E) practices. These processes allow for continuous tracking and adjustments, ensuring efficiency and cost-effectiveness throughout the project lifecycle.`,
  },
];

const value = [
  {
    icon: "../../images/icons/advice.png",
    title: "Tailored Approach",
    body: "We understand each client’s uniqueness and develop customized strategies that lead to tailored, impactful outcomes. Our solutions are designed to address immediate needs while providing lasting value.",
  },
  {
    icon: "../../images/icons/it_support.png",
    title: "Strong & Experienced Personnel",
    body: "We prioritize competence and ensure that every member of our team is equipped to successfully deliver on their assignments.",
  },
  {
    icon: "../../images/icons/softdev.png",
    title: "Disruptive Thinking",
    body: "We shorten our clients' journey by streamlining processes, ensuring they reach their goals more efficiently while maintaining the highest standards of quality and integrity.",
  },
  {
    icon: "../../images/icons/core.png",
    title: "Efficient Process",
    body: "We specialize in helping our clients design and implement lean systems that optimize efficiency and drive profitability. By reducing waste and enhancing operational effectiveness, we enable businesses to achieve sustainable growth and maximize their financial returns.",
  },
];

const aboutValue = [
  {
    icon: "../../images/icons/vision.png",
    title: "Vision",
    body: "Our Vision is to deploy systems that can interpret the dreams of everyday people, governments and corporations in Nigeria, Africa and across the world.",
  },
  {
    icon: "../../images/icons/mission.png",
    title: "Mission",
    body: "To provide end-to-end business advisory and management support services; creating alignment between dreams and reality.",
  },
];

const aboutPicture = "../../images/about/about.png";
const contactPicture =
  "linear-gradient(to top, rgba(255, 255, 255, 0), rgba(0, 0, 0, 1)), url(../../images/contact/boardroom.png)";

const servicesPicture =
  "linear-gradient(to top, rgba(255, 255, 255, 0), rgba(0, 0, 0, 1)), url(../../images/services/office.png)";

const teamPicture =
  "linear-gradient(to top, rgba(255, 255, 255, 0), rgba(0, 0, 0, 1)), url(../../images/team/team.png)";

const storyImages = [
  "../../images/about/001.png",
  "../../images/about/002.png",
  "../../images/about/003.png",
  "../../images/about/004.png",
  "../../images/about/005.png",
  "../../images/about/006.png",
  "../../images/about/008.png",
  "../../images/about/009.png",
  "../../images/about/010.png",
  "../../images/about/011.png",
  "../../images/about/012.png",
  "../../images/about/013.png",
  "../../images/about/014.png",
  "../../images/about/015.png",
  "../../images/about/016.png",
  "../../images/about/017.png",
  "../../images/about/018.png",
  "../../images/about/019.png",
  "../../images/about/020.png",
  "../../images/about/007.png",
];

const coreProfiles = [
  {
    image: "../../images/team/fisayo.png",
    name: "Fisayo Okunsanya",
    role: "Head, Executive Management",
    expertise: "Strategy, Leadership, Finance",
  },
  {
    image: "../../images/team/maryjane.png",
    name: "Maryjane Ugbaja",
    role: "Head, Corporate Services",
    expertise: "Operations, Governance, Efficiency",
  },
  {
    image: "../../images/team/david.png",
    name: "David Ebenezer",
    role: "Head, Analytical Services",
    expertise: "Insight, Analysis, Optimization",
  },
  {
    image: "../../images/team/chizoba.png",
    name: "Chizoba Ezirim",
    role: "Head, Projects",
    expertise: "Planning, Coordination, Execution",
  },
];

const teamProfiles = [
  {
    image: "../../images/team/fisayo.png",
    firstName: "Fisayo",
    lastName: "Okunsanya",
    role: "Head, Executive Management",
    expertise: "Strategy, Leadership, Finance",
    phone: "+2348023187712",
    email: "fisayo@6334group.net",
    linkedIn: "",
    twitter: "",
    bio: "Fishy's Bio",
  },
  {
    image: "../../images/team/maryjane.png",
    firstName: "Maryjane",
    lastName: "Ugbaja",
    role: "Head, Corporate Services",
    expertise: "Operations, Governance, Efficiency",
    phone: "+2348068285774",
    email: "maryjane@6334group.net",
    linkedIn: "",
    twitter: "",
    bio: `Maryjane is a media and communications consultant with over 15 years of diverse experience across telecommunications, media production, and consulting. Proven track record as a budding A-list actress and producer, a branding and communications specialist, and public relations strategist for both public and private sectors. Mjay is a passionate human capacity builder, dedicated to empowering individuals to gain self-awareness and solidify their brand identity through purpose-driven training.`,
  },
  {
    image: "../../images/team/david.png",
    firstName: "David",
    lastName: "Ebenezer",
    role: "Head, Analytical Services",
    expertise: "Insight, Analysis, Optimization",
    phone: "+2348032052713",
    email: "david@6334group.net",
    linkedIn: "",
    twitter: "",
    bio: "Dave's Bio",
  },
  {
    image: "../../images/team/chizoba.png",
    firstName: "Chizoba",
    lastName: "Ezirim",
    role: "Head, Projects",
    expertise: "Planning, Coordination, Execution",
    phone: "+2348035387835",
    email: "zoba@6334group.net",
    linkedIn: "",
    twitter: "",
    bio: `Chizoba Ezirim was on the foundation team of Capital oil and industries limited where he rose from entry level to become Assistant Regional Manager (Southeast operations) in just 14 months. He left for Westmall Oil and Gas as Head of Retail, then to Coos Oil and Gas Co. Ltd as Head of The Diesel Supply Network.\n\nAfter his years in the oil and gas industry, he decided to pursue his age long dream of helping Nigeria Enterprises reach the 100-year landmark and exceed it.\n\nChizoba has been involved in providing strategic advisory, and business planning services to several Small and Medium Enterprises in different industries which include, but not limited to Healthcare, Oil & Gas, Hospitality, Power, Financial services, Agriculture, and Construction in Nigeria. Over the years he has developed skills and experience as a Business Analyst, and business growth specialist working with teams on several engagements including; Crafting and implementation of Strategy (Lagos state MoH, KwHmB, Medbury medical services, Falcon corporation, Falcon Gas limited, Quest oil and engineering,  new owners of Ascon oil company Limited, Dugo Limited, Jude Elswitch Limited), Business Performance Review (Urban Dice designs limited, Colonades Hotel, Midas Touch microcredit program), Project Management ( JNCI, A-B Agro allied limited, Gricpro Farms limited), and Training (Sterling bank, Access bank, 1st Bank, Colonnades Hotel, and Ancilla catholic hospital)\n\nHe is a certified Business Strategy and Operations Professional from The International Business Management Institute (IBMI) Berlin and presently a  Senior Business Analyst, and head of Projects at 6334 Business Services.`,
  },
  {
    image: "../../images/team/lola.png",
    firstName: "Lola Mariam",
    lastName: "Alli",
    role: "Designation",
    expertise: "Quality, Quality, Quality",
    phone: "+2348099526153",
    email: "lola@6334group.net",
    linkedIn: "",
    twitter: "",
    bio: `Lola Mariam Alli is a distinguished health economist and strategic advisor who transforms complex healthcare systems into value-generating entities that serve African citizens. With over eight years of specialized experience in healthcare policy development, she brings exceptional analytical rigor and implementation expertise to government partnerships across the continent.\n\nA first-class graduate in Economics from both Newcastle University and the University of Cambridge, Ms. Alli combines world-class academic credentials with practical experience designing healthcare financing mechanisms that work within African contexts. Her technical assistance has strengthened healthcare governance frameworks in multiple jurisdictions, directly improving service delivery for vulnerable populations.\n\nAs a trusted advisor, Ms. Alli has pioneered evidence-based approaches that align policy objectives with fiscal realities while prioritizing equity and access. Her methodology for healthcare system assessment has been adopted by several national and state governments, resulting in measurable improvements in healthcare resource allocation and service delivery metrics.\n\nMs. Alli's expertise spans health financing reform, public-private partnerships in healthcare delivery, and the development of sustainable national health insurance schemes. She has successfully guided government stakeholders through complex policy transitions, ensuring continuity of care while implementing necessary structural reforms.\n\nBeyond policy development, Ms. Alli excels at building capacity within government institutions, transferring critical skills to local teams and establishing robust monitoring frameworks that drive accountability and continuous improvement in public health systems.\n\nGuided by the principle that equitable healthcare access represents a fundamental human need, she remains dedicated to transforming health systems that respond effectively to citizens' needs while optimizing limited resources. Her collaborative, impact-oriented approach has established her as an invaluable partner to governments committed to healthcare transformation.\n\nWhen not advancing public health initiatives across Africa, Ms. Alli can be found in her studio either painting or sculpting.`,
  },
  {
    image: "../../images/team/juliet.png",
    firstName: "Juliet",
    lastName: "Mabi",
    role: "Senior Analyst",
    expertise: "Strategy, Technical, Influencial",
    phone: "+2347033073018",
    email: "juliet@6334group.net",
    linkedIn: "",
    twitter: "",
    bio: "Juliet's Bio",
  },
  {
    image: "../../images/team/profile.png",
    firstName: "Banke",
    lastName: "Equagoo",
    role: "Designation",
    expertise: "Organized, Detailed, Discreet",
    phone: "+2349086444489",
    email: "banke@6334group.net",
    linkedIn: "",
    twitter: "",
    bio: "Banke's Bio",
  },
  {
    image: "../../images/team/bethel.png",
    firstName: "Bethel",
    lastName: "Esamah",
    role: "Designation",
    expertise: "Quality, Quality, Quality",
    phone: "+2347014385158",
    email: "bethel@6334group.net",
    linkedIn: "",
    twitter: "",
    bio: "Bethel's Bio",
  },
  {
    image: "../../images/team/adepero.png",
    firstName: "Dr. Adepero",
    lastName: "Nathan",
    role: "Designation",
    expertise: "Quality, Quality, Quality",
    phone: "+2348073171200",
    email: "adepero@6334group.net",
    linkedIn: "",
    twitter: "",
    bio: `Dr. Adepero Nathan is a Medical doctor and MBA candidate at Quantic School of Business and Technology. She holds certifications in Leadership & Management in Healthcare, Policy Development & Advocacy for Global Health, and Project Management in Global Health from the University of Washington.\n\nWith strong clinical experience across emergency and primary health settings in top Nigerian hospitals, Adepero has also led strategic management and due diligence projects for various healthcare organizations.\n\nShe supported the Lagos State Ministry of Health through the Bill & Melinda Gates Foundation, driving improvements in primary health service delivery across 319 public facilities. She has also served as Technical Assistant to the National Coordinator of the National AIDS, Viral Hepatitis, and STIs Control Programme under Nigeria’s Federal Ministry of Health.`,
  },
  {
    image: "../../images/team/profile.png",
    firstName: "Moyosore",
    lastName: "Adeleke",
    role: "Designation",
    expertise: "Quality, Quality, Quality",
    phone: "+2348139436160",
    email: "moyosore@6334group.net",
    linkedIn: "",
    twitter: "",
    bio: "Moyo's Bio",
  },
  {
    image: "../../images/team/bolu.png",
    firstName: "Boluwatife",
    lastName: "Dosunmu",
    role: "Designation",
    expertise: "Innovative, Precise, Adapdable",
    phone: "+2347068529099",
    email: "bolu@6334group.net",
    linkedIn: "",
    twitter: "",
    bio: `Boluwatife Dosunmu is a Biomedical Engineer who graduated from the University of Ilorin in 2022. She is currently a Graduate Member of the Nigerian Society of Engineers (NSE).\n\nHer academic background includes certifications in Occupational and Environmental Safety and Health (HSE), Level I Award in Health and Safety at work (2020); Level II Award in Risk Assessment Practical Application (2020) and Level III Award in Environmental Awareness (2020) from the World Safety Organization (USA).\n\nBoluwatife possesses extensive engineering experience, having worked in the Biomedical Engineering departments at renowned hospitals such as the University College Hospital, Ibadan and St Nicholas Hospital in Lagos Island.\n\nIn addition to her biomedical engineering work, Boluwatife has undertaken various strategic management and due diligence projects for numerous healthcare organizations under the umbrella of 6334 management consulting including Hosanna Specialist Hospital Ilaro Ogun State, Pearl Hospital Lagos State, Medbury Medical Services, Mixta Africa, ICS Outsourcing, MeCure Industries Limited, Evercare Hospital etc.`,
  },
  {
    image: "../../images/team/chioma.png",
    firstName: "Chioma",
    lastName: "Ndeche",
    role: "Designation",
    expertise: "Quality, Quality, Quality",
    phone: "+2348054866906",
    email: "chioma@6334group.net",
    linkedIn: "",
    twitter: "",
    bio: `Chioma Princess Ndeche is a 5th-year medical student at the College of Medicine, University of Lagos, with a strong background in healthcare, leadership, communications, and advocacy.\n\nShe currently serves as the Learning and Development Manager for AIESEC in Lagos and has held various roles including Social Secretary of AMSUL (2023/2024), Speaker Liaison for TEDxCMUL, and Disciplinary Committee Chair for AIESEC. Her international experience includes serving as IComms Manager for AIESEC in Thailand, where she led national campaigns that boosted visibility and engagement.\n\nBeyond leadership, Chioma writes as a columnist for The Guardian Life, volunteers with the M. Kukoyi Foundation to teach CPR and emergency care, and has interned in healthcare management with organizations like 6334, focusing on system efficiency and patient-centered care.\n\nShe enjoys public speaking, event planning, and leveraging creativity for social impact. Outside her professional interests, Chioma is a cat lover, fantasy fiction enthusiast, and restaurant explorer.`,
  },
  {
    image: "../../images/team/godwill.png",
    firstName: "Godwill",
    lastName: "Kinding",
    role: "Business/Administrative Management",
    expertise: "Organized, Decisive, Diplomatic",
    phone: "+2348035893305",
    email: "godwill@6334group.net",
    linkedIn: "",
    twitter: "",
    bio: "Godwill's Bio",
  },
  {
    image: "../../images/team/kanyin.png",
    firstName: "Kanyinsola",
    lastName: "Adeniran",
    role: "Data and IT Chief",
    expertise: "Visionary, Analytical, Strategic",
    phone: "+2348055038792",
    email: "kanyin@6334group.net",
    linkedIn: "",
    twitter: "@Kanyinsola",
    bio: "KK's Bio",
  },
];

const logos = [
  "../../images/logos/abbott1.png",
  "../../images/logos/BMGF.png",
  "../../images/logos/cerba.png",
  "../../images/logos/cleveland.png",
  "../../images/logos/edc.png",
  "../../images/logos/hfn.png",
  "../../images/logos/IOGC.png",
  "../../images/logos/JNCI.png",
  "../../images/logos/lagos.png",
  "../../images/logos/LECC.png",
  "../../images/logos/lifeworth.png",
  "../../images/logos/marigold.png",
  "../../images/logos/medbury.png",
  "../../images/logos/nepal.png",
  "../../images/logos/quest.png",
  "../../images/logos/ruff.png",
  "../../images/logos/utopian.png",
];

const testimonials = [
  {
    testimonial:
      "6334 exceeded our expectations with their innovative corporate strategy, transforming our operations and driving significant growth and efficiency. We highly recommend their services for exceptional results.",
    author: "Mary Johnson",
    designation: "CEO",
    company: "BlueTech Solutions",
  },
  {
    testimonial:
      "Working with 6334 was a game-changer. Their team's expertise in business support provided practical and effective solutions, leaving our company in a much stronger position.",
    author: "David Williams",
    designation: "COO",
    company: "Apex Industries",
  },
  {
    testimonial:
      "6334's professionalism and insight are unmatched. Their expertise in healthcare systems streamlined our processes, helping us better serve our clients. They have been an exceptional partner.",
    author: "Fatima Ali",
    designation: "Director of Operations",
    company: "MediCare Global",
  },
  {
    testimonial:
      "6334's data management solutions were exactly what we needed, improving our operations significantly. Their attention to detail and commitment to excellence are truly commendable.",
    author: "Michael O'Reilly",
    designation: "CTO",
    company: "DataSync Enterprises",
  },
  {
    testimonial:
      "Our partnership with 6334 has been outstanding. Their strategic insights and ability to navigate challenges have greatly impacted our business. We look forward to continuing our collaboration.",
    author: "Linda Chen",
    designation: "Managing Director",
    company: "Horizon Ventures",
  },
];

const servicesData = [
  {
    title: "Business Consulting",
    description:
      "Our business consulting services provide strategic advice to help organizations optimize operations, improve efficiency, and achieve their business goals. We focus on actionable strategies and tailored solutions.",
    image: "../../images/services/business.webp",
  },
  {
    title: "Financial Advisory",
    description:
      "We offer financial advisory services that include investment planning, risk management, and financial analysis to support informed decision-making for both personal and business finance.",
    image: "../../images/services/advisory.png",
  },
  {
    title: "Data Analytics",
    description:
      "Our data analytics services transform raw data into meaningful insights to support data-driven decision-making. We specialize in data visualization, reporting, and predictive modeling.",
    image: "../../images/services/analytics.png",
  },
  {
    title: "Corporate Strategy",
    description:
      "We help organizations develop and implement corporate strategies that align with their mission, vision, and long-term goals. Our services include strategic planning, market positioning, and competitive analysis.",
    image: "../../images/services/strategy.webp",
  },
  {
    title: "Project Management",
    description:
      "Our project management services ensure successful project delivery through planning, execution, and monitoring. We follow best practices to keep projects on schedule and within budget.",
    image: "../../images/services/project.png",
  },
];

const faqData = [
  {
    question: "What types of consultancy services do you offer?",
    answer:
      "We specialize in a wide range of consultancy services, including business strategy development, project management, organizational restructuring, market research, and data analysis. Our team of experts is also equipped to handle niche sectors such as healthcare consultancy, financial advisory, and technology implementation. Each service is tailored to meet the unique needs and objectives of our clients, ensuring sustainable growth and long-term success.",
  },
  {
    question: "How do you approach a new project for a client?",
    answer:
      "Our approach begins with an in-depth understanding of your business objectives and challenges. We conduct a comprehensive needs assessment, followed by market research and stakeholder interviews. This allows us to define the project scope and develop a strategic roadmap. We then collaborate closely with your team to implement the solution, ensuring continuous feedback and refinement throughout the project lifecycle.",
  },
  {
    question: "What industries do you have experience working with?",
    answer:
      "We have extensive experience working across various industries, including healthcare, finance, manufacturing, and technology. Our consultants have helped startups, SMEs, and large enterprises optimize their operations, enter new markets, and achieve significant cost savings. By leveraging our industry knowledge and cross-functional expertise, we can offer innovative solutions that address both common and industry-specific challenges.",
  },
  {
    question: "Can you provide references or case studies from past clients?",
    answer:
      "Yes, we can provide case studies and references upon request, subject to client confidentiality agreements. Our case studies detail the challenges our clients faced, the solutions we implemented, and the measurable outcomes achieved. These references demonstrate our ability to deliver tangible results and our commitment to client satisfaction.",
  },
  {
    question:
      "What is your typical project timeline and how do you ensure deadlines are met?",
    answer:
      "Project timelines vary depending on the complexity and scope of the engagement. For small-scale projects, timelines can range from a few weeks to a couple of months, while larger projects may span several months. To ensure deadlines are met, we employ a robust project management framework with defined milestones and deliverables. Regular status updates and transparent communication keep all stakeholders informed and aligned throughout the project.",
  },
];

const socialMediaIcons = [
  {
    label: "WhatsApp",
    icon: "../../images/icons/whatsapp.png",
    link: "https://www.whatsapp.com/",
  },
  {
    label: "LinkedIn",
    icon: "../../images/icons/linkedin.png",
    link: "https://www.linkedin.com/company/76556369",
    color: "#0077b5",
  },
  {
    label: "X",
    icon: "../../images/icons/twitter.png",
    link: "https://www.twitter.com/",
    color: "#1DA1F2",
  },
  {
    label: "Instagram",
    icon: "../../images/icons/instagram.png",
    link: "https://www.instagram.com/6334group/",
  },
  {
    label: "TikTok",
    icon: "../../images/icons/tiktok.png",
    link: "https://www.tiktok.com/",
  },
  {
    label: "Facebook",
    icon: "../../images/icons/facebook.png",
    link: "https://www.facebook.com/",
  },
  {
    label: "YouTube",
    icon: "../../images/icons/youtube.png",
    link: "https://www.youtube.com/results?search_query=fisayo+okunsanya",
  },
];

const contactIcons = [
  { label: "phone", image: "../../images/svg/phone.svg" },
  { label: "email", image: "../../images/svg/message.svg" },
  { label: "linkedin", image: "../../images/svg/linkedin.svg" },
  { label: "linkedin", image: "../../images/svg/twitter.svg" },
];
// TEXT
// Home Page
const homeAboutHeading = "We are a business advisory firm";
const homeAboutEssay = [
  "At our core, we believe that excellence is both achievable and essential to every endeavor. Our mission is to empower private and public enterprises to unlock their full potential by focusing on innovation, efficiency, and sustainability.",
  // "We help organizations maximize their capacity by providing tailored solutions that streamline processes, reduce waste, and boost efficiency. By leveraging creativity and unique strengths, we guide businesses toward greater operational success.",
  "With a deep understanding of various sectors, we work closely with clients to implement strategies that drive growth and performance. Our commitment to excellence ensures that potential is transformed into lasting success.",
];

const homeValueHeading = "We think differently";
const homeValueEssay = [
  "We believe that excellence is not just a goal but a guiding principle that drives innovation, fosters progress, and underpins everything we do. Our mission is to help private and public enterprises unlock their full potential, aligning strategic goals with innovative practices to thrive in complex environments. We focus on fostering efficiency and promoting sustainability, ensuring that growth is both rapid and responsible.",
  // "By taking a comprehensive approach, we enable businesses to seize opportunities, optimize operations, and achieve long-term success. We help transform ambition into measurable achievements, empowering our partners to exceed the demands of today’s marketplace and create lasting value.",
];

const homeCompetenciesHeading = "Our Core Competencies";
const homeCompetenciesEssay = [
  "6334 Group is a team of seasoned professionals with a proven track record of successfully managing and delivering complex projects across the public and private sectors. We specialize in providing tailored, innovative solutions that not only meet clients' immediate objectives but also evolve with their ongoing needs. Our iterative approach ensures continuous refinement and optimization, with a steadfast commitment to excellence, innovation, and client satisfaction in every project we undertake.",
];

const homeClientHeading = "Our Clientele";
const homeClientEssay = [
  "Over the years, 6334 Group has had the privilege of partnering with a diverse range of esteemed clients across various industries. Our client portfolio spans both public and private sectors, reflecting our ability to adapt and deliver tailored solutions in dynamic and complex environments.",
  // "We take pride in the trust placed in us by our clients and our proven ability to consistently exceed expectations. Our partnerships are built on a foundation of mutual respect, collaboration, and a shared commitment to achieving outstanding results.",
];

const homeConclusionEssay = [
  "We constantly strive to assist private and public enterprises with maximizing their capacity to create value by harnessing their creativity, limiting wastage and increasing efficiency. Let us work together.",
];

// About Us Page
const aboutIntroHeading = "About Us";
const aboutIntroEssay = ["Innovative Strategies, Measurable Success"];

const aboutWhoHeading = "Who we are";
const aboutWhoEssay = [
  "We believe that excellence is an achievable standard in every endeavor, and we are committed to helping private and public enterprises unlock their full potential to create sustainable value. By fostering innovation and tailoring our solutions to each organization’s unique needs, we empower businesses to harness their creativity, minimize wastage, and drive operational efficiency. Through strategic guidance and hands-on support, we help streamline processes and optimize resources, positioning organizations to consistently achieve superior outcomes and thrive in competitive environments.",
];

const aboutStoryHeading = "Our Story";
const aboutStoryEssay = [
  "We believe excellence is an achievable standard in every endeavor and are dedicated to helping private and public enterprises unlock their full potential to create sustainable value. By fostering innovation and crafting solutions tailored to each organization’s unique needs, we enable businesses to harness creativity, reduce wastage, and drive operational efficiency.",
  "Through strategic guidance and hands-on support, we help streamline processes and optimize resources. This approach positions organizations to consistently achieve superior outcomes and thrive in increasingly competitive environments.",
];
const aboutStoryEssay2 = [
  "Our journey has been marked by growth, adaptation, and a steadfast commitment to excellence. As we expand our services, we invite prospective clients to join us in unlocking new opportunities and driving sustainable growth. With innovative strategies and trusted expertise, we help you navigate today’s complexities and achieve exceptional outcomes.",
];

const aboutTeamHeading = "Our Team";
const aboutTeamEssay = [
  "Our success is driven by a diverse team of industry leaders, innovative thinkers, and strategic problem-solvers. Committed to delivering tailored solutions, our professionals work collaboratively to ensure each project meets the highest standards of quality and impact. The strength of our company lies in the collective expertise, creativity, and dedication of our people.",
];

const aboutWhatHeading = "What we do";
const aboutWhatEssay = [
  "At the core of our consultancy services is a commitment to delivering tailored, innovative solutions that drive tangible results. We partner with organizations across various industries, offering strategic guidance and hands-on support to help them achieve their goals. By combining deep industry knowledge with a forward-thinking mindset, we customize solutions for optimizing operations, developing sustainable growth strategies, and enhancing organizational structures, empowering our clients to excel in their fields.",
];

const aboutValuesHeading = "Our Values";
const aboutValuesEssay = [
  "At the core of our consultancy lies a set of fundamental values that guide our actions and decisions. These principles shape our approach to client relationships, drive our commitment to excellence, and inspire our team to innovate continuously. We believe that upholding these values not only enhances our work but also empowers our clients to achieve sustainable success.",
];

const aboutTestimonialsHeading = "Testimonials";
const aboutTestimonialsEssay = [
  "Hear from those who’ve experienced our expertise firsthand—insights from clients who’ve partnered with us to achieve lasting success and transformation.",
];

const aboutMeetingHeading = "Book a Meeting";
const aboutMeetingEssay = [
  "Ready to Transform Your Vision into Reality?",
  "At 6334, we understand that every organization has unique challenges and goals. Our dedicated team of experts is here to partner with you, providing tailored solutions that drive results. Let us help you navigate your journey toward success with confidence and clarity.",
];

// Contact Us Page
const contactIntroHeading = "Get in Touch with 6334";
const contactIntroEssay = [
  "We’re here to help. Reach out to us for inquiries, collaborations, or to start a project.",
];

const contactDetailsHeading = "Reach out to Us";

const contactFAQsHeading = "FAQs";

// Services Page
const servicesIntroHeading = "How Can We Help?";
const servicesIntroEssay = [
  "Tailored solutions to drive your business forward.",
];

const servicesServicesHeading = "Our Services";
const servicesServicesEssay = [
  "Discover how our tailored solutions and strategic insights empower organizations to achieve their goals. We provide a range of professional services designed to address complex challenges, drive innovation, and deliver measurable impact across diverse sectors.",
];

// Team Page
const teamIntroHeading = "Our Team";
const teamIntroEssay = ["Meet the Squad."];

// 6334 AANALYTICS DATA

const analyticsMenuOptions = [
  {
    label: "Data Dashboard",
    path: "/analytics",
  },
  {
    label: "Reports",
    path: "/analytics/reports",
  },
  {
    label: "Interactive Maps",
    path: "/analytics/maps",
  },
  {
    label: "Downloads",
    path: "/analytics/downloads",
  },
  {
    label: "Publications",
    path: "/analytics/publications",
  },
];

export {
  siteKey,
  secretKey,
  phoneNumber,
  dark,
  light,
  isTabWidth,
  whiteLogo,
  menuItems,
  buildings,
  designBarButtons,
  endButtons,
  teamButtons,
  servicesButtons,
  contactButtons,
  contactHeaderButtons,
  servicesHeaderButtons,
  sentences,
  competences,
  value,
  aboutValue,
  aboutPicture,
  contactPicture,
  servicesPicture,
  teamPicture,
  storyImages,
  coreProfiles,
  teamProfiles,
  logos,
  testimonials,
  servicesData,
  faqData,
  socialMediaIcons,
  contactIcons,
  //Texts
  //Home
  homeAboutHeading,
  homeAboutEssay,
  homeValueHeading,
  homeValueEssay,
  homeCompetenciesHeading,
  homeCompetenciesEssay,
  homeClientHeading,
  homeClientEssay,
  homeConclusionEssay,
  //About Us
  aboutIntroHeading,
  aboutIntroEssay,
  aboutWhoHeading,
  aboutWhoEssay,
  aboutStoryHeading,
  aboutStoryEssay,
  aboutStoryEssay2,
  aboutTeamHeading,
  aboutTeamEssay,
  aboutWhatHeading,
  aboutWhatEssay,
  aboutValuesHeading,
  aboutValuesEssay,
  aboutTestimonialsHeading,
  aboutTestimonialsEssay,
  aboutMeetingHeading,
  aboutMeetingEssay,
  // Contact Us
  contactIntroHeading,
  contactIntroEssay,
  contactDetailsHeading,
  contactFAQsHeading,
  // Services
  servicesIntroHeading,
  servicesIntroEssay,
  servicesServicesHeading,
  servicesServicesEssay,
  // Team
  teamIntroHeading,
  teamIntroEssay,
  teamHeaderButtons,
  // 6334 AANALYTICS DATA
  analyticsMenuOptions,
};
